var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"station-container"},[(_vm.selectedNode.type == _vm.productCodes.station)?_c('StationHeader'):_c('GroupHeader'),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"box-content"},[_c('StationBase')],1)]),(_vm.showSpin)?_c('Spin',{attrs:{"fix":""}},[_vm._v(_vm._s(_vm.spinContent))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }